import React, { ReactElement, useEffect } from 'react';
import { Form } from 'formik';
import { typeOfPENBOptions } from '../../../../../data/enumerations';
import { useDataCollection } from '../../../../../hooks';
import { InjectedWizardStepProps } from '../../../../components/Steps/WizardStep';
import CheckCard from '../../../../components/Form/CheckCard';
import { WizardStep } from '../../../../../types';
import StepHeader from '../../../../components/Layout/StepHeader';

const StepTypeOfPENB = ({ completeStep, setNextStepId }: InjectedWizardStepProps): ReactElement<'div'> | null => {
    const { handleChange, values } = useDataCollection();
    useEffect(() => {
        if (values.penBType) {
            const nextStepId =
                values.penBType === typeOfPENBOptions[0].value
                    ? WizardStep.MeasuredHeatLossPENB
                    : WizardStep.AvgHeatTransferOfBuildingPENB;
            setNextStepId && setNextStepId(nextStepId);
            completeStep && completeStep(true);
        }
    }, [values]);

    return (
        <Form>
            <div className="otz-main otz-main--notice">
                <StepHeader title="Jaký PENB máte?"/>
                <div className={'otz-main__grid'}>
                    {typeOfPENBOptions.map(({ value, title, description, img }) => {
                        return (
                            <div key={value} className={'wiz-card wiz-card--notice'}>
                                <CheckCard
                                    name={'penBType'}
                                    onChange={handleChange}
                                    checked={values.penBType === value}
                                    value={value}
                                >
                                    <div className={'check-card__inner'}>
                                        <div className={'check-card__image'}>
                                            <img src={img} alt="check-card-img" />
                                        </div>
                                        <div className="check-card__text">
                                            <h3 className="check-card__title">{title}</h3>
                                            <p className="check-card__desc">{description}</p>
                                        </div>
                                    </div>
                                </CheckCard>
                            </div>
                        );
                    })}
                </div>
            </div>
        </Form>
    );
};

export default StepTypeOfPENB;
